import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import ConditionalPrice from 'components/text/ConditionalPrice/ConditionalPrice'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './GiftSetPrice.scss'


const GiftSetPrice = ({ className, priceWithDiscount, price }) => (
  <div className={cx(s.priceSection, className)}>
    <Text message={messages.price} tag="span" />
    <ConditionalPrice className={s.prices} price={price} discountedPrice={priceWithDiscount} isCents />
  </div>
)

GiftSetPrice.propTypes = {
  priceWithDiscount: PropTypes.number,
  price: PropTypes.number.isRequired,
}

export default GiftSetPrice
